import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Autorenew} from "@mui/icons-material";

import IconButton from "components/button/IconButton";
import CustomTooltip from "components/CustomTooltip";
import {ListContext} from "components/List/context/ListContext";

import {pushShippingMethodNow} from "api/shippingMethod/pushNow";

PushNowButton.propTypes = {
    shippingMethod: PropTypes.object.isRequired,
    onPushed: PropTypes.func.isRequired,
};

// A push only follows a change: this one pushes as is, e.g. once the pricing was set on Sylius.
function PushNowButton({shippingMethod, onPushed}) {
    const [pushing, setPushing] = useState(false);
    const {showErrorNotification} = useContext(ListContext);

    // off for return-only, virtual or unclassified methods, and while the organization's push is off
    if (!shippingMethod.syliusPushEnabled) {
        return null;
    }

    return (
        <CustomTooltip title={<FormattedMessage id={'shippingMethods.sync.pushNow'}/>} placement={'top'}>
            <span>
                <IconButton
                    disabled={pushing}
                    aria-label={'push'}
                    onClick={(event) => {
                        event.stopPropagation();
                        setPushing(true);

                        pushShippingMethodNow(shippingMethod)
                            .then(() => onPushed())
                            .catch(() => showErrorNotification())
                            .finally(() => setPushing(false));
                    }}
                >
                    <Autorenew fontSize={'small'} sx={pushing ? {animation: 'spin 1s linear infinite', '@keyframes spin': {to: {transform: 'rotate(360deg)'}}} : undefined}/>
                </IconButton>
            </span>
        </CustomTooltip>
    );
}

export default PushNowButton;
